import { Direction } from '@angular/cdk/bidi';
import { Directive, Injector, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { DeleteDialogComponent } from 'src/formio-custom-components/src/lib/shared/components/delete-dialog/delete-dialog/delete-dialog.component';
import { CommonQuestionsService, QuestionsStoreService } from '../services';

@Directive()
export class ComponentBase implements OnDestroy {
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() viewOnly: boolean;

  destroy$ = new Subject<void>();

  translateService = this.injector.get(TranslateService);
  toastrService = this.injector.get(ToastrService);
  dialog: MatDialog = this.injector.get(MatDialog);

  questionsService = this.injector.get(CommonQuestionsService);
  questionsStore = this.injector.get(QuestionsStoreService);
  /**
   *
   */
  constructor(public injector: Injector) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected _confirmDialog({
    title = this.translateService.instant('MESSAGES.confirmTitle'),
    description = this.translateService.instant('MESSAGES.confirmDescription'),
    confirmText = this.translateService.instant('GLOBAL.confirm'),
    direction = 'rtl',
  }: {
    title?: string;
    description?: string;
    confirmText?: string;
    direction?: Direction;
  } = {}) {
    return this.dialog.open(DeleteDialogComponent, {
      width: 'min(80%, 500px)',
      direction: direction,
      panelClass: 'padding-zero',
      data: {
        title: title,
        description: description,
        confirmText: confirmText,
      },
    });
  }

  protected _showSuccessAlert({
    title = 'OperationDone',
    message = 'MESSAGES.savedSuccessfully',
  }: {
    title?: string;
    message?: string;
  } = {}) {
    this.toastrService.success(
      this.translateService.instant(message),
      this.translateService.instant(title)
    );
  }

  protected _showErrorAlert({
    title = 'ERRORS.generalError',
    message = 'ERRORS.ErrorOccurred',
  }: {
    title?: string;
    message?: string;
  } = {}) {
    this.toastrService.error(
      this.translateService.instant(title),
      this.translateService.instant(message)
    );
  }
}
